import React, { useState, useEffect } from 'react';
import { Range, getTrackBackground } from 'react-range';
import FilterContainer from './FilterContainer';
import DropdownContainer from './DropdownContainer';

function FilterRangeSlider(props) {
  const {
    taxonomy,
    taxSlug,
    selected,
    displayPostCounts,
    label,
    collapsible,
    scrollable,
    dropdown,
    labelTitle,
    replaceSelected,
    isSelected,
    tooltip,
    tooltipLeftContent,
    tooltipRightContent
  } = props;

  const [closeRequest, setCloseRequest] = useState(false);
  const [values, setValues] = useState([parseInt(taxonomy[0].value), parseInt(taxonomy[1].value)]);
  const filterId = taxSlug ? `filter-${taxSlug}` : '';

  useEffect(() => {
    if (! selected || ! selected[taxSlug] || ! selected[taxSlug].length) {
      setValues([parseInt(taxonomy[0].value), parseInt(taxonomy[1].value)]);
    }
  }, [selected]);

  // let parentContent;
  // let childContent;
  let filterContent;
  let rangeSlider = <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap'
    }}
  >
    <div className="range-slider-output" style={{ width: '100%' }} id="output">
      ${values[0].toFixed().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} - ${values[1].toFixed().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
    </div>
    <Range
      values={values}
      step={100}
      min={parseInt(taxonomy[2].value)}
      max={parseInt(taxonomy[3].value)}
      onChange={(values) => {
        setValues(values);
      }}
      onFinalChange={(values) => {
        valueChange(values);
      }}
      renderTrack={({ props, children }) => (
        <div
          onMouseDown={props.onMouseDown}
          onTouchStart={props.onTouchStart}
          style={{
            ...props.style,
            height: '20px',
            display: 'flex',
            width: 'calc(100% - 16px)'
          }}
        >
          <div
            ref={props.ref}
            style={{
              height: '2px',
              width: '100%',
              borderRadius: '0',
              background: getTrackBackground({
                values,
                colors: ['#6E7677', '#0074E0', '#6E7677'],
                min: parseInt(taxonomy[2].value),
                max: parseInt(taxonomy[3].value)
              }),
              alignSelf: 'center'
            }}
          >
            {children}
          </div>
        </div>
      )}
      renderThumb={({ props, isDragged }) => (
        <div
          {...props}
          style={{
            ...props.style,
            height: '16px',
            width: '16px',
            border: '2px solid #0074E0',
            borderRadius: '8px',
            backgroundColor: '#fff',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            outline: 'none'
          }}
        />
      )}
    />
  </div>;

  function valueChange(values) {
    replaceSelected(5, taxSlug, values);
  }

  if (dropdown) {
    filterContent = <DropdownContainer
      selected={selected}
      taxSlug={taxSlug} 
      taxonomy={taxonomy}
      closeRequest={closeRequest}
      setCloseRequest={setCloseRequest}
      defaultLabel={label} 
      labelTitle={labelTitle}
      >
        <div className="dropdown-list">
          {rangeSlider}
        </div>
      </DropdownContainer>
  }
  else {
    filterContent = <div>
      {rangeSlider}
    </div>
  }

  return (
    <FilterContainer 
    className="filter-range-slider"
    label={label}
    filterId={filterId}
    collapsible={collapsible}
    scrollable={scrollable}
    tooltip={tooltip}
    tooltipLeftContent={tooltipLeftContent}
    tooltipRightContent={tooltipRightContent}
    labelTitle={labelTitle}
    >
      {filterContent}
    </FilterContainer>
  )
}

export default FilterRangeSlider;